/* eslint-disable no-unused-vars */
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { useEffect, useState, useRef } from 'react';
import Classic from '@ckeditor/ckeditor5-build-classic';
import { Form } from 'antd';
import { useSelector } from 'react-redux';

function DokanTinyEditor({
    DisableMargin,
    setHeight,
    config = {},
    FormInputName,
    FormInputLabel,
    FormInputRules,
    onValueChange,
}) {
    // Handle Editor....
    const changeInputField = (name, value) => {
        console.log('editor', name, value);
        onValueChange(name, value);
    };

    const getInputData = useSelector((state) => state.products.productInputData);
    const InputData = { ...getInputData };
    const setInputData = InputData[FormInputName];
    return (
        <>
            <div className={`${!DisableMargin && 'mt-20px'}`}>
                <Form.Item name={FormInputName} label={FormInputLabel} rules={FormInputRules}>
                    <CKEditor
                        editor={Classic}
                        config={{}}
                        onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                            // console.log("Editor is ready to use!", editor);
                            editor.editing.view.change((writer) => {
                                writer.setStyle(
                                    {
                                        height: setHeight,
                                        //  border: '1px solid rgba(233, 238, 248, 0.9)',
                                    },
                                    editor.editing.view.document.getRoot()
                                );
                            });
                        }}
                        data={setInputData}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            changeInputField(FormInputName, data);
                        }}
                    />
                </Form.Item>
            </div>
        </>
    );
}

export default DokanTinyEditor;
